import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { BrandService } from 'services';
@Injectable()
export class BrandReorderGuard {
    constructor(
        private brandService: BrandService,
        private router: Router
    ) {}

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.brandService.userBrands.pipe(
            map((userBrands) => {
                const hasReorderBrands = _.some(userBrands, ['fcProducts.orderPlatform.participates', true]);
                if (hasReorderBrands) {
                    return true;
                }
                this.router.navigate(['manufacturer-platform/news']);
                return false;
            })
        );
    }
}
